require("../../node_modules/jquery-ui/ui/position");

module.exports = {
  init: () => {
    const trigger = $(".header-menu-item--hasdropdown > a");
    trigger.click(function() {
      const listElement = $(this).closest(".header-menu-item--hasdropdown");
      listElement.toggleClass("header-menu-item--open");
      $(".header-menu-item")
        .not(listElement)
        .each(function() {
          $(this).removeClass("header-menu-item--open");
        });

      return false;
    });

    initMenu();

    $(window).resize(function() {
      initMenu();
    });

    function initMenu() {
      $.each($(".header-menu-item-dropdown"), function(index, value) {
        $(this).position({
          my: "left-30 top",
          at: "left bottom",
          of: $(this).closest(".header-menu-item--hasdropdown"),
          collision: "fit none",
          within: $(".header-wrapper")
        });
      });
    }

    var eventType = navigator.userAgent.match(/iPad/i) ? "touchstart" : "click";
    $("html, body").on(eventType, function(e) {
      if ($(e.target).closest(".header-menu-item-dropdown").length === 0) {
        $(".header-menu-item").removeClass("header-menu-item--open");
      }
    });
  }
};
